import React from 'react';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-purple py-16 sm:py-20" data-id="element-29" data-mp="3ucdmq0r6l2m8">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-30" data-mp="3udyhnrheqnkm">
        <Reveal data-id="element-31" data-mp="c7aggcphakk8">
          <p className="font-script text-3xl text-gold sm:text-4xl" data-id="element-32" data-mp="c7tzxxus1h0d">Shopping made easy, swift and reliable.</p>
          <h2 className="mt-4 font-display text-3xl uppercase leading-tight tracking-tight text-white sm:text-5xl" data-id="element-33" data-mp="83m5dk1n16u8">
            Just name it. We got you covered.
          </h2>
        </Reveal>
        <Reveal delay={0.12} data-id="element-34" data-mp="h52ihzju7n25">
          <a href="#order" className="mt-8 inline-block rounded-full bg-gold px-9 py-4 text-sm font-bold text-purple-deep shadow-lift transition duration-200 hover:-translate-y-1 hover:scale-[1.03] hover:bg-gold-light hover:shadow-xl active:scale-100 sm:text-base" data-id="element-35" data-mp="h3rcru6u058e">
            Start Your Market Run
          </a>
        </Reveal>
      </div>
    </section>;
}